import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, HostListener } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Header } from '../../../model/header';
import { IconComponent } from '../icon/icon.component';
import { Icons } from '../../../model/icon';
import { dateFormatYYYYMMDDTODDMMYYYY, getPropValue } from '../../../functions/getValue';

@Component({
  selector: 'app-sortable-table',
  imports: [
    NgForOf,
    NgIf,
    IconComponent
  ],
  templateUrl: './sortable-table.component.html',
  standalone: true,
  styleUrl: './sortable-table.component.scss'
})
export class SortableTableComponent implements OnChanges {
  @Input() headers: Header[] = [];
  @Input() data: any[] = [];
  @Input() currentSortHeader: string = '';
  @Input() currentSort: string = '';
  @Input() getClearSorting: number = 0;
  @Output() openItemEmit: EventEmitter<number> = new EventEmitter();
  @Output() currentSortHeaderEmit: EventEmitter<string> = new EventEmitter();
  @Output() currentSortEmit: EventEmitter<string> = new EventEmitter();
  @Output() sortEmit: EventEmitter<string> = new EventEmitter();

  isTab: boolean = false;
  isMobile: boolean = false;

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isTab = window.innerWidth <= 768;
    this.isMobile = window.innerWidth <= 521;
  }

  openItemRow(row: any) {
    this.openItemEmit.emit(row.id ?? -1);
  }

  openItem(event: Event, row: any) {
    event.stopPropagation();
    this.openItemEmit.emit(row.id ?? -1);
  }

  sort(column: Header) {
    if (column.sortable === false || column.edit) {
      return;
    }
    let newSort = '';
    let newSortHeader = column.key;
    if (this.currentSortHeader === column.key) {
      switch (this.currentSort) {
        case 'asc':
          newSort = 'desc';
          break;
        case 'desc':
          newSort = '';
          newSortHeader = '';
          break;
        case '':
          newSort = 'asc';
          break;
        default:
          newSort = 'asc';
      }
    } else {
      newSort = 'asc';
    }
    this.currentSortHeader = newSortHeader;
    this.currentSort = newSort;
    this.currentSortHeaderEmit.emit(newSortHeader);
    this.currentSortEmit.emit(newSort);
    const sortQuery = newSort === '' ? '' : `${column.key}:${newSort.toUpperCase()}`;
    this.sortEmit.emit(sortQuery);
  }

  clearSorting() {
    this.currentSortHeader = '';
    this.currentSort = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['getClearSorting'] && this.getClearSorting > 0) {
      this.clearSorting();
    }
  }

  protected readonly environment = environment;
  protected readonly Icons = Icons;
  protected readonly getPropValue = getPropValue;
  protected readonly dateFormatYYYYMMDDTODDMMYYYY = dateFormatYYYYMMDDTODDMMYYYY;
}
